import type { Association } from "../types/legacyBusiness.types";
import logo from "../../assets/images/logo.jpg";
import placeholder from "../../assets/images/placeholder.webp";

export const associationData: Association = {
  name: "APINATIVOS",
  logo: logo,
  slogan: "Asociación de Productores Prestadores de Servicios y Turismo del Pacífico Sur",
  description: "La Asociación APINATIVOS (Asociación de Productores Prestadores de Servicios y Turismo del Pacífico Sur) es una organización comunitaria ubicada en Coto Brus, Puntarenas, Costa Rica, que promueve el desarrollo sostenible a través del fortalecimiento de iniciativas locales en turismo rural, producción agroecológica y conservación ambiental. Integrada por productores, emprendedores y prestadores de servicios turísticos. APINATIVOS trabaja en la promoción de la cultura local, el empoderamiento de las comunidades y la protección del patrimonio natural del Pacífico Sur costarricense. Su labor fomenta la economía solidaria y la articulación de redes colaborativas para mejorar la calidad de vida de sus miembros y visitantes.",
  history: "Don Gilbert, ebanista de profesión, conoció al apicultor Carlos Azofeifa, quien le pidió fabricar cajas para sus colmenas. De ahí nació su pasión por la apicultura, lo que llevó a la creación de la cooperativa Coopeapi. Aunque esta se disolvió tras cinco años, algunos miembros se reagruparon con apoyo de la Universidad de Costa Rica y el Tour de las Abejas. En agosto de 2023 nació oficialmente la marca APINATIVOS, consolidando su compromiso con el desarrollo sostenible.",
  mission: "",
  vision: "",
  contactInfo: {
    email: "",
    phone: "",
    address: "50 metros este de Agroservicio La Poderosa y 50 metros sur, Coto Brus, Puntarenas, Costa Rica"
  },
  socialMedia: {
    facebook: "https://www.facebook.com/apinativos",
    instagram: "",
    whatsapp: ""
  },
  galleryImages: [
    placeholder,
    placeholder,
    placeholder,
    placeholder,
    placeholder,
    placeholder
  ]
};
